import {makeApiCall} from '../index';
import type { ItemEnvelope, CustomerSearchResult } from '@ruta/shared';

export interface UnifiedSearchResults {
  results: {
    customers: CustomerSearchResult[];
    services: any[];
    templates: any[];
    serviceAreas: any[];
  };
  count: {
    customers: number;
    services: number;
    templates: number;
    serviceAreas: number;
  };
  query: string;
}

export const unifiedSearch = async (
  query: string,
  types?: string[],
  limit?: number
): Promise<UnifiedSearchResults> => {
  const params = new URLSearchParams();
  params.append('q', query);

  if (types && types.length > 0) {
    params.append('types', types.join(','));
  }

  if (limit) {
    params.append('limit', limit.toString());
  }

  const res = await makeApiCall<ItemEnvelope<UnifiedSearchResults>>(
    'GET',
    `/search?${params.toString()}`,
  );
  return res.data;
};
